import React, { useState, useMemo } from 'react';
import { Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import useBuyerSuplierSearch from './useBuyerSuplierSearch';

const BuyerSupplierSearch = ({
    label,
    handleInputChange,
    handleOnChange,
    error,
    errorMessage,
    value,
    name,
    disabled,
    multiple = false,
}) => {
    const [selected, setSelected] = useState(value || []);

    const { options, isLoading, search } = useBuyerSuplierSearch(); // Use the custom hook

    const handleInput = useMemo(() => {
        return (query) => {
            search(query);
            handleInputChange && handleInputChange(query);
        };
    }, [search, handleInputChange]);

    const onChangeType = (selectedOptions) => {
        setSelected(selectedOptions);
        handleOnChange(selectedOptions);
    };

    return (
        <>
            <label className='text-neutral-800 mb-1 font-b3 text-start'>{label.name}</label>
            <Typeahead
                disabled={disabled}
                name={label.name}
                id={label.id}
                //labelKey='name'
                labelKey={(option) => (option.name ? `${option.name}` : '')}
                multiple={multiple}
                options={options || []}
                isLoading={isLoading}
                placeholder={label.placeholder}
                size='sm'
                onInputChange={handleInput}
                onChange={onChangeType}
                selected={selected}
                defaultSelected={value ? value : []}
                renderMenu={(results, menuProps) => (
                    <Menu {...menuProps}>
                        {results?.map((result, index) => (
                            <MenuItem key={result.ulid || result.id || result.name} option={result} position={index}>
                                {result.name} 
                            </MenuItem>
                        ))}
                        {results?.length === 0 ? (
                            <p key={'noData'} className='mb-0 font-b2 ps-2'>
                                No Data Found
                            </p>
                        ) : null}
                    </Menu>
                )}
            />
            {error && <p className='text-error-700 font-b3 font-regular mt-2'>{errorMessage}</p>}
        </>
    );
};

export default BuyerSupplierSearch;
